import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import AuthorPage from "@/pages/author/page";
import ComicDetailPage from "@/pages/comic/page";
import ReadPage from "@/pages/read/page";
import NewsListPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/newsdetail/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:categoryId", element: <CategoryPage /> },
      { path: "author/:authorId", element: <AuthorPage /> },
      { path: "comic/:comicId", element: <ComicDetailPage /> },
      { path: "read/:comicId/:chapterId", element: <ReadPage /> },
      { path: "news", element: <NewsListPage /> },
      { path: "news/:newsId", element: <NewsDetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;